module.exports = __webpack_public_path__ + "knife.jpg?025086a5ee282f85ffdac839b13aa7a8";